module.exports = __webpack_public_path__ + "static/Mailsculpt-Image-3-fb8789d5d12db6a023750003f8a94be6.jpg";